module.exports = __webpack_public_path__ + "img/pay-pal.e922bbb0.svg";